module.exports = __webpack_public_path__ + "static/img/products_green_enegry.da4467f2.jpg";